var resetTransform = function (a) {
    a.css({
        '-webkit-transform': '',
        '-moz-transform': '',
        '-ms-transform': '',
        '-o-transform': '',
        'transform': ''
    });
};
var proportionalScroll = function () {
    var a = $('#proportional-anchor-2');
    var b = $('#proportional-anchor-1');
    var rh = $('#' + a.data("relId")).outerHeight(true) ? $('#' + a.data("relId")).outerHeight(true) : 0;
    var ah = a.outerHeight() + rh;
    var bh = b.outerHeight();
    var wh = $(window).height();
    var diff = Math.abs(ah - bh);
    var k = 60;
    var scrollToTop = $(window).scrollTop();
    if (ah < bh && scrollToTop != 0) {
        var j = scrollToTop - b.offset().top + wh / 2;
        var ratio = ((bh - ah) / (bh));
        var c = j * ratio;
        //var c = c - rh;
        var c = c < 0 ? 0 : (c > diff ? diff : c);
        a.css({
            '-webkit-transform': 'translate(0px, ' + c + 'px)',
            '-moz-transform': 'translate(0px,' + c + 'px)',
            '-ms-transform': 'translate(0px,' + c + 'px)',
            '-o-transform': 'translate(0px,' + c + 'px)',
            'transform': 'translate(0px,' + c + 'px)'
        });
    }
    else if ($(window).scrollTop() == 0) {
        var c = 0;
        a.css({
            '-webkit-transform': 'translate(0px, ' + c + 'px)',
            '-moz-transform': 'translate(0px,' + c + 'px)',
            '-ms-transform': 'translate(0px,' + c + 'px)',
            '-o-transform': 'translate(0px,' + c + 'px)',
            'transform': 'translate(0px,' + c + 'px)'
        });
    }
};
var smallMql = window.matchMedia('(min-width: 768px)');
smallMql.addListener(screenTest);
function screenTest(e) {
    if (e.matches) {
        $(document).on('ready scroll', proportionalScroll);
    } else {
        resetTransform($('#proportional-anchor-2'));
        $(document).off('ready scroll', proportionalScroll);
    }
}
screenTest(smallMql);

